import * as types from 'store/mutation-types'

// initial state
const state = {
  theme: 'skin-2',
  fixednav: false,
  rightsidebar: false,
  alarmrightsidebar1: false,
  alarmrightsidebar2: false,
  alarmrightsidebar3: false,
  versionNo: '',
  showBackMission: false,
  refreshCount: 0
}

// actions
const actions = {
  // 改变主题
  changetheme ({ commit }, theme) {
    commit(types.THEME_CHANGE, theme)
  },
  // 顶部固定
  fixednav ({ commit }, val) {
    commit(types.FIXED_NAV, val)
  },
  // 右侧边栏
  rightsidebar ({ commit }) {
    commit(types.RIGHT_SIDEBAR)
  },
  // 报警右侧边栏
  alarmrightsidebar ({ commit }, num) {
    commit(types.ALARM_RIGHT_SIDEBAR, num)
  },
  // 获取版本信息
  getVersion ({commit}, version) {
  	commit(types.GET_VERSION_NO, version)
  },
  // 打开后台任务组件
  showMission ({commit}, bool) {
  	commit(types.SHOW_BACK_MISSION, bool)
  },
  refreshStatus ({commit}, no) {
  	commit('toRefreshStatus', no)
  }
}

// mutations
const mutations = {
  // 改变主题
  [types.THEME_CHANGE] (state, theme) {
  	 state.theme = theme
  },
  // 顶部固定
  [types.FIXED_NAV] (state, val) {
  	 state.fixednav = val
  },
  // 右侧边栏
  [types.RIGHT_SIDEBAR] (state) {
  	 state.rightsidebar = !state.rightsidebar
  },
  // 报警右侧边栏
  [types.ALARM_RIGHT_SIDEBAR] (state, num) {
  	 if (num == 0) {
  	 	  state.alarmrightsidebar1 = false
  	 		state.alarmrightsidebar2 = false
  	 	  state.alarmrightsidebar3 = false
  	 }
  	 if (num == 1) {
  	 	  state.alarmrightsidebar1 = !state.alarmrightsidebar1
  	 	  state.alarmrightsidebar2 = false
  	 	  state.alarmrightsidebar3 = false
  	 }

  	 if (num == 2) {
  	 	  state.alarmrightsidebar2 = !state.alarmrightsidebar2
  	 	  state.alarmrightsidebar1 = false
  	 	  state.alarmrightsidebar3 = false
  	 }

  	 if (num == 3) {
  	 	  state.alarmrightsidebar3 = !state.alarmrightsidebar3
  	 	  state.alarmrightsidebar1 = false
  	 	  state.alarmrightsidebar2 = false
  	 }
  },
  [types.GET_VERSION_NO] (state, version) {
  	state.versionNo = version
  },
  [types.SHOW_BACK_MISSION] (state, bool) {
  	if (bool) {
  		state.showBackMission = !state.showBackMission
  	} else {
  		state.showBackMission = false
  	}
  },
  toRefreshStatus (state, no) {
  	state.refreshCount ++
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js